module.exports = __webpack_public_path__ + "img/ico-finish.4f8e37fa.svg";